import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';
import MypageReturn from '../molecules/MypageReturn';

interface Props {
  is_staff: boolean;
  reception_cd: string;
  status_code: number;
  moveNextStep: VoidFunction;
  reception_id: number;
}

// KWANKGM04070_本審査結果確認
// KWANKGM04140_農業資金本審査結果確認
const FooterConfirmationOfMainExaminationResults: React.FC<Props> = ({
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
}) => {
  const history = useHistory();

  const handleClickNext = () => {
    moveNextStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/confirm`);
  };

  return (
    <>
      <RowCenterButton>
        <DefaultButton label="契約申込に進む" strong={false} handleClick={handleClickNext} />
      </RowCenterButton>
      <MypageReturn is_staff={is_staff} />
    </>
  );
};

export default memo(FooterConfirmationOfMainExaminationResults);
